import React from "react";
import { useTranslation } from "react-i18next";

const LegendItem = ({ color, text, description = "" }) => (
  <div className="flex items-center gap-2 group">
    <div
      className={`h-5 w-5 rounded ${color} border border-neutral-200 dark:border-neutral-700 shadow-sm flex-shrink-0`}
    ></div>
    <div>
      <span className="text-sm font-medium">{text}</span>
      {description && (
        <p className="text-xs text-muted-foreground hidden group-hover:block mt-0.5">
          {description}
        </p>
      )}
    </div>
  </div>
);

const ParkingLegend = ({ className = "flex-col" }) => {
  const { t } = useTranslation();

  return (
    <div className={`flex gap-4 flex-wrap ${className}`}>
      <LegendItem
        color="bg-purple-100 dark:bg-purple-900/30"
        text={t("parking.legend.items.reserved.title")}
        description={t("parking.legend.items.reserved.description")}
      />
      <LegendItem
        color="bg-blue-100 dark:bg-blue-900/30"
        text={t("parking.legend.items.yourSpot.title")}
        description={t("parking.legend.items.yourSpot.description")}
      />
      <LegendItem
        color="bg-white dark:bg-neutral-900"
        text={t("parking.legend.items.private.title")}
        description={t("parking.legend.items.private.description")}
      />
    </div>
  );
};

export default ParkingLegend;
